import * as type from '../constants/ActionTypes';
import { AFFILIATE_SERVICE_URL, ORDER_SERVICE_URL } from '../constants/api';
import { CALL_API } from '../login/api.middleware';
import { throwIfMissing } from "../utils/action.utils";

export function fetchReturns({
  clientId = throwIfMissing('clientId'),
  affiliateId = throwIfMissing('affiliateId')
}) {
  return {
    [CALL_API]: {
      endpoint: `${AFFILIATE_SERVICE_URL}/returns`,
      authenticated: true,
      params: {
        returnStatus: 'new',
        clientId: clientId,
        affiliateId: affiliateId
      },
      types: [
        type.RETURNS_REQUEST,
        type.RETURNS_SUCCESS,
        type.RETURNS_FAILURE
      ]
    }
  };
}



export function forceReturnValidation(returnId) {

  return {
    [CALL_API]: {
      endpoint: `${AFFILIATE_SERVICE_URL}/returns/update`,
      authenticated: true,
      config: {
        method: 'PUT',
        posAllowed: localStorage.posAllowed,
        body: JSON.stringify({returnId: returnId, valid:true })
      },
      types: [
        type.FORCE_RETURN_VALIDATION_REQUEST,
        type.FORCE_RETURN_VALIDATION_SUCCESS,
        type.FORCE_RETURN_VALIDATION_FAILURE
      ]
    }
  };
}



export function fetchReturnInfo(purchaseId){

  return {
    [CALL_API]: {
      endpoint: `${ORDER_SERVICE_URL}/reservations/views/tickets`,
      authenticated: true,
      params: {
        purchaseId: purchaseId,
      },
      types: [
        type.RETURN_INFO_REQUEST,
        type.RETURN_INFO_SUCCESS,
        type.RETURN_INFO_FAILURE
      ]
    }
  };


}